export default __webpack_public_path__ + "static/media/a2.6adce48c.png";